module.exports = __webpack_public_path__ + "img/btn_1_hover.a34b50d0.png";